<div [style.display]="state() === 'inactive' ? 'none' : ''">
  <img class="toastr-icon icon-close" src="assets/images/icon-alert-close.png" (click)="remove()" />

  <div [class]="options().titleClass" [attr.aria-label]="title()">
     @if (icon) {
      <i
        class="material-symbols-outlined header-icon"
        [class.spin]="icon === 'progress_activity'">
        {{ icon }}
      </i>
    }
    @else {
      <img class="toastr-icon icon-alert" [src]="iconImage" />
    }
    {{ title() }}
  </div>

  <div role="alert" aria-live="polite" [class]="options().messageClass" [attr.aria-label]="message()">
    <span [innerHTML]="message()"></span>
  </div>

  @if (showBtns) {
    <div class="d-flex align-items-center mt-2">
      <div class="me-3" (click)="onView()">{{ viewText }}</div>

      @if (copyLink) {
        <div (click)="onCopyLink($event)">{{ copyLinkText }}</div>
      }
    </div>
  }

</div>
